/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Remove Selected Events" |
*
* @param {Remove_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_event_aria_label = /** @type {((inputs?: Remove_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les Evenements Selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover eventos selecionados")
	return /** @type {LocalizedString} */ ("Remove Selected Events")
});